import type { ReactElement } from 'react';
import { BrandMark } from '@/components/brand/brand-mark';
import { LanguageToggle } from '@/components/language-toggle';
import { useTranslation } from '@/lib/i18n';
import { appHost } from '@/lib/hosts';

// The apex root until Phase 8 opens the discovery page here: a branded page
// that says what this is, rather than a directory that does not exist yet. §21
export function LandingPage(): ReactElement {
  const { t } = useTranslation();
  const staffHost = appHost();

  return (
    <div className="flex min-h-full flex-col">
      <header className="relative overflow-hidden bg-linear-to-br from-cyan-700 via-cyan-600 to-sky-300 px-6 px-safe pt-12 pt-safe pb-10 text-center text-white">
        <div className="absolute top-3 right-3 mt-safe">
          <LanguageToggle />
        </div>
        <BrandMark className="mx-auto size-20" />
        <h1 className="mt-3 text-2xl font-extrabold tracking-tight sm:text-3xl">{t('brand')}</h1>
        <p className="text-sm opacity-85">{t('tagline')}</p>
        <p className="mx-auto mt-3 max-w-md text-sm opacity-90">{t('landingLead')}</p>
      </header>

      <main className="mx-auto flex w-full max-w-md flex-1 flex-col gap-4 p-6 text-center text-sm">
        <p className="text-muted-foreground">{t('landingVenueHint')}</p>
        <p className="text-muted-foreground">{t('landingSoon')}</p>
        {staffHost !== '' && (
          <p className="text-muted-foreground">
            {t('landingStaff')}{' '}
            <a className="font-medium text-primary underline" href={`https://${staffHost}/`}>
              {staffHost}
            </a>
          </p>
        )}
      </main>
    </div>
  );
}
